import GrantRequestService from '../../services/GrantRequestService';
import grantRequestUseCase from './grantRequestUseCase';

const grantRequestFactory = grantRequestUseCase({
  GrantRequestService: GrantRequestService(),
});

export default grantRequestFactory;
